export default __webpack_public_path__ + "static/media/main-ambient.d88ae0c3.mp3";